import * as types from "../constants/actionTypes";
import { availabilityReducer } from "./availabilityReducer";

export const ratesReducer = (state = [], action) => {
  switch (action.type) {
    case types.SORT_BY_LOWEST_PRICE: {
      const nextState = sortRatesByLowestPrice(state);
      return nextState;
    }
    case types.RATE_SELECTED:
    case types.RATE_UNSELECTED: {
      //const { rateId, priceCode, planCode } = action.payload;
      const { rateId, allocationCode, roomInventory } = action.payload;
      const selectedIsAllocation = !!allocationCode;

      const nextState = state.map(rate => {
        const currentRateIsNoneAllocation = !rate.allocationCode;
        const isSameAllocation = allocationCode === rate.allocationCode;
        const isAllocationRateGtInventory =
          rate.allocationCode && rate.availability > roomInventory;
        const notTheSameRateId = rate.id !== rateId;
        const shouldUpdateRate =
          (notTheSameRateId && (selectedIsAllocation && isSameAllocation)) ||
          isAllocationRateGtInventory ||
          currentRateIsNoneAllocation;

        if (shouldUpdateRate) {
          return {
            ...rate,
            availability: availabilityReducer(rate.availability, action)
          };
        }
        return rate;
      });
      return nextState;
    }

    default:
      return state;
  }
};

export const getRateById = (state, id) => {
  const rate = state && state.find(r => r.id === id);
  return rate;
};

const sortRatesByLowestPrice = state =>
  state
    .slice() // for no mutations
    .sort((a, b) => {
      if (a.totalPrice > b.totalPrice) return 1;
      else if (a.totalPrice === b.totalPrice) return 0;
      else {
        return -1;
      }
    });

export const filteredAvailableRates = state =>
  state.filter(rate => rate.availability > 0);



// WEBPACK FOOTER //
// ./src/reducers/ratesReducer.js